const triggers = document.querySelectorAll(".collapsible__trigger");

const footerAccordionQuery = window.matchMedia("(min-width: 768px)");

function syncFooterAccordionAria() {
  document.querySelectorAll(".footer .collapsible__trigger").forEach((trigger) => {
    if (footerAccordionQuery.matches) {
      trigger.setAttribute("aria-expanded", "true");
    }
  });
}

triggers.forEach((trigger) =>
  trigger.addEventListener("click", function () {
    const container = this.closest(".collapsible");
    const expanded = container.classList.toggle("collapsible--expanded");
    this.setAttribute("aria-expanded", expanded);
    syncFooterAccordionAria();
  })
);

syncFooterAccordionAria();
footerAccordionQuery.addEventListener("change", syncFooterAccordionAria);
